import React from 'react';
import Styled from 'styled-components';
import PropTypes from 'prop-types';
import { Dropdown, Input } from 'semantic-ui-react';

export const LabelSection = Styled.b`
  display: block;
  margin-bottom: 5px;
`;

export const FilterSelect = ({ label, onChange, options, placeholder, value, isLoading = false }) => (
  <div>
    <LabelSection>{label}</LabelSection>
    <Dropdown
      value={value}
      onChange={onChange}
      search
      fluid
      placeholder={placeholder}
      selection
      options={options}
      loading={isLoading}
    />
  </div>
);

export const FilterInput = ({ label, onBlur, value, onChange }) => (
  <div>
    <LabelSection>{label}</LabelSection>
    <Input fluid value={value} onBlur={onBlur} onChange={onChange} />
  </div>
);

FilterSelect.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  isLoading: PropTypes.bool,
};

FilterInput.propTypes = {
  label: PropTypes.string,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  onChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/components/ProcessoImpresa/ImpresaFilterBar/filterBarElements.js